import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { addValidator, required } from 'redux-form-validators';
import { MODAL_QUESTION_MULTY_FORM, hideModal } from '../../../../../modules/modals';
import { deleteImgs } from '../../../../helpers/Fields/EditorMedia/actions';
import EditorMedia from '../../../../helpers/Fields/EditorMedia/EditorMedia';
import SelectFieldAnt from '../../../../helpers/Fields/SelectFieldAnt';
import TreeSelectField from '../../../../helpers/Fields/TreeSelectField';
import UploadImageField from '../../../../helpers/Fields/UploadImageField';
import { createQuestion, getCategoriesUp, updateQuestion } from '../../../actions';
import Modal from 'react-modal';
import {uniqueId } from 'lodash';
import TextField from './components/TextField/TextField';
import TextFieldWysiwyg from './components/TextFieldWysiwyg/TextFieldWysiwyg';
import SwitchField from '../../../../helpers/Fields/SwitchField';
import './style.scss';
import Answers from './components/Answers/Answers';

const textValidate = addValidator({
  validator: function(options, value, allValues) {
    let tmp = value.trim().replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<br\/>/g, '').replace(/<br>/g, '').replace(/ /g, "")
    if(!tmp){
      return {
        id: "form.errors.question",
        defaultMessage: 'is required',
      }
    }
    return true
    
  }
})

export class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.deleteImages = [];
    this.state = {
      spinner: true,
      modal: false,
    }
    this.refAnswers = React.createRef();
    this.refQuestion = React.createRef();
  }

  componentWillUnmount(){
    if(this.deleteImages.length){
      deleteImgs(this.deleteImages)
    }
  }

  addedImage = (src) => {
    this.deleteImages.push(src);
  }

  submit = async (value) => {
    const {updateQuestion, createQuestion, hideModal, getCategoriesUp, subject_selcted} = this.props;
    this.deleteImages = [];
    if(value.id){
      await updateQuestion(value)
      this.props.handleClose();
    } else {
      await createQuestion(value);
      this.setState({modal: true})
    }
  }

  render() {
    const {formatMessage} = this.context;
    const {handleSubmit, handleClose, change} = this.props;
    const {categories, subjects, valuesForm} = this.props;
    const {modal} = this.state;

    let tree = [];

    categories.filter(_i => _i.subject_id == valuesForm.subject_id).forEach(cat => {
      if(!cat.parent_id){
        tree.push({
          title: cat.name,
          value: cat.id,
          children: []
        })
      }
    });

    categories.forEach(cat => {
      if(cat.parent_id){
        tree.forEach(item => {
          if(item.value == cat.parent_id){
            item.children.push({
              title: cat.name,
              value: cat.id,
            })
          }
        })
      }
    });

    return <form className='QuestionFormData' onSubmit={handleSubmit(this.submit)}>
      <Modal
        isOpen = {modal}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseCreateQuestionModal')}</div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextCreateQuestionModal')}</div>
            <div className="create-dialog-form__group flex">
              <button 
                className="btn btn-primary" 
                type="button" 
                onClick={() => {
                  this.setState({modal: false});
                  this.props.reset();
                  change('question_type', valuesForm.question_type);
                  const value = valuesForm.question_type;
                  if(value == 'type1'){
                    change('answers', '');
                  } else if(value == 'type2'){
                    change('answers', [
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        text: '',
                        url: '',
                        isTrue: true,
                      },
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        text: '',
                        url: '',
                        isTrue: false,
                      },
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        text: '',
                        url: '',
                        isTrue: false,
                      },
                    ]);
                  } else if(value == 'type3'){
                    change('answers', [
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        text: '',
                        url: '',
                        order: 1,
                        isTrue: false,
                      },
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        text: '',
                        url: '',
                        order: 2,
                        isTrue: false,
                      },
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        text: '',
                        url: '',
                        order: 3,
                        isTrue: false,
                      },
                    ]);
                  } else if(value == 'type4'){
                    change('answers', [
                      {
                        _id: uniqueId('answer-') + Date.now(),
                        url: '',
                        title: '',
                        variants: [
                          {
                            _id: uniqueId('variant-') + Date.now(),
                            text: '',
                            url: '',
                            order: 1,
                            isTrue: false,
                          },
                        ],
                      },
                    ]);
                  } else if(value == 'type5') {
                    change('answers', {
                      value: '',
                      variants: [],
                    });
                  } else if(value == 'type6') {
                    change('answers', {
                      image: '',
                      variants: [],
                    });
                  } else if(value == 'type7') {
                    change('answers', [
                      {
                        _id: uniqueId('variant-') + Date.now(),
                        question: '',
                        answer: ''
                      }
                    ]);
                  }
                  
                }}
              >{formatMessage('Yes')}</button>
              <button className="btn btn-warning" type="button" onClick={() => {this.props.hideModal({ modalType : MODAL_QUESTION_MULTY_FORM})}}>{formatMessage('No')}</button>
            </div>
          </div>
          
        </div>
      </Modal>
      <Field 
        name='subject_id'
        label={formatMessage('questionSubject')}
        component={SelectFieldAnt}
        handleChange={() => {
          change('category_id', '')
        }}
        options={subjects.map(_i => ({value: _i.id, title: _i.name}))}
        validate={[required()]}
      />
      <Field 
        name='category_id'
        label={formatMessage('questionCategory')}
        component={TreeSelectField}
        tree={tree}
        validate={[required()]}
      />
       <Field 
        name='question_type'
        label={formatMessage('questionType')}
        component={SelectFieldAnt}
        handleChange={(value) => {
          console.log("🚀 ~ file: FormContent.jsx ~ line 155 ~ FormContent ~ render ~ value", value)
          if(value == 'type1'){
            change('answers', '');
          } else if(value == 'type2'){
            change('answers', [
              {
                _id: uniqueId('answer-') + Date.now(),
                text: '',
                url: '',
                isTrue: true,
              },
              {
                _id: uniqueId('answer-') + Date.now(),
                text: '',
                url: '',
                isTrue: false,
              },
              {
                _id: uniqueId('answer-') + Date.now(),
                text: '',
                url: '',
                isTrue: false,
              },
            ]);
          } else if(value == 'type3'){
            change('answers', [
              {
                _id: uniqueId('answer-') + Date.now(),
                text: '',
                url: '',
                order: 1,
                isTrue: false,
              },
              {
                _id: uniqueId('answer-') + Date.now(),
                text: '',
                url: '',
                order: 2,
                isTrue: false,
              },
              {
                _id: uniqueId('answer-') + Date.now(),
                text: '',
                url: '',
                order: 3,
                isTrue: false,
              },
            ]);
          } else if(value == 'type4'){
            change('answers', [
              {
                _id: uniqueId('answer-') + Date.now(),
                url: '',
                title: '',
                variants: [
                  {
                    _id: uniqueId('variant-') + Date.now(),
                    text: '',
                    url: '',
                    order: 1,
                    isTrue: false,
                  },
                ],
              },
            ]);
          } else if(value == 'type5') {
            change('answers', {
              value: '',
              variants: [],
            });
          } else if(value == 'type6') {
            change('answers', {
              image: '',
              variants: [],
            });
          } else if(value == 'type7') {
            change('answers', [
              {
                _id: uniqueId('variant-') + Date.now(),
                question: '',
                answer: ''
              }
            ]);
          }
        }}
        options={[
          {title: formatMessage('equalText'), value: 'type1'},
          {title: formatMessage('multySeleteAnswer'), value: 'type2'},
          {title: formatMessage('sortAnswers'), value: 'type3'},
          {title: formatMessage('sortAnswersCategories'), value: 'type4'},
          {title: formatMessage('equalTextVariants'), value: 'type5'},
          {title: formatMessage('imageLabel'), value: 'type6'},
          {title: formatMessage('matchingQuestions'), value: 'type7'},
        ]}
        validate={[required()]}
      />
      <Field name="question" label={formatMessage('questionQuestion')} validate={[textValidate()]} component={TextField} />
      <Answers rootChange={change} answers={valuesForm.answers} questionType={valuesForm.question_type} formatMessage={formatMessage} />
      <Field name="description" label={formatMessage('descriptionQuestion')} validate={[]} component={TextField} />
      <div className="create-dialog-form__group flex" style={{justifyContent: 'center', marginTop: 20,
            flexDirection: 'row'}}>
           <button className="btn btn-primary" type="submit">{formatMessage('btnModalSaveQuestion')}</button>
        </div>
    </form>;
  }
}

const FormContentData = reduxForm({
  form: 'form_question',
  enableReinitialize: true,
})(FormContent);

const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_question')(state),
  categories: state.question.categories_all,
  subject_selcted: state.question.subject_selcted,
  subjects: state.question.subjects,
})

const mapDispatchToProps = {
  createQuestion,
  updateQuestion,
  getCategoriesUp,
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContentData);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/FormContent.jsx